import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SpStrategyCreationComponent } from "@m19-board/sponsored-product/sp-page/sp-substrategy-creation/sp-strategy-creation.component";

@Component({
  selector: "app-sp-strategy-group-creation",
  template: ` <app-sp-strategy-creation [isSubStrategyCreation]="false" /> `,
  imports: [SpStrategyCreationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpStrategyGroupCreationComponent {}
